import type { EquipmentAccessorialType } from './constants.ts'
import { createEquipmentCategory } from './internal.ts'

const refrigeratedAccessorials: EquipmentAccessorialType[] = [
  'food-grade',
  'temp',
  'team-driver',
  'tanker-endorsement',
]

export const refrigeratedEquipment = createEquipmentCategory(
  {
    bucket: 'refrigerated',
    mode: 'truckload',
    workflows: ['truckload'],
    accessorialTypes: refrigeratedAccessorials,
  },
  [
    { key: 'refrigerated-48', name: "Refrigerated 48'" },
    { key: 'refrigerated-53', name: "Refrigerated 53'" },
    {
      key: 'partial-refrigerated',
      name: 'Partial refrigerated',
      workflows: ['truckload', 'ltl'],
    },
  ],
)
